import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, first } from 'rxjs/operators';
import { User } from '@app/_models';

@Injectable({ providedIn: 'root' })
export class AccountService {
    private userSubject: BehaviorSubject<User | null>;
    public user: Observable<User | null>;

    constructor(
        private router: Router,
        private http: HttpClient
    ) {
        this.userSubject = new BehaviorSubject(JSON.parse(sessionStorage.getItem('user')!));
        this.user = this.userSubject.asObservable();
    }

    public get userValue() {
        return this.userSubject.value;
    }

    login(email: string, password: string) {
        return this.http.post<User>('/account/login', { email, password })
            .pipe(map(user => {
                // store user details and jwt token in local storage to keep user logged in between page refreshes
                sessionStorage.setItem('user', JSON.stringify(user));
                this.userSubject.next(user);
                return user;
            }));
    }

    logout() {
        // remove user from local storage and set current user to null
        sessionStorage.removeItem('user');
        this.userSubject.next(null);
        return new Observable((subscriber) => subscriber.next());
        // la siguiente llamada es para limpiar la cookie 'token'
        return this.http.get('/logout').pipe(first());
    }

    register(user: User) {
        return this.http.post('/api/users', user);
    }

    getAll(obFilter?: object) {
        let f = '';
        if (obFilter) {
            //f = '?' + Object.entries(obFilter).map(x => x.join('=')).join('&');
            f = '?' + stringi(obFilter).substring(1);
        }
        return this.http.get<User[]>(`/api/users${f}`);
    }

    getById(id: string) {
        return this.http.get<User>(`/api/users/${id}`);
    }

    update(id: string, params: User) {
        //console.log(JSON.stringify(params));
        params._id = id;
        return this.http.put<User>(`/api/users/${id}`, params)
            .pipe(map(x => {
                // update stored user if the logged in user updated their own record
                if (id == this.userValue?._id) {
                    // update local storage
                    const user = { ...this.userValue, ...params };
                    sessionStorage.setItem('user', JSON.stringify(user));

                    // publish updated user to subscribers
                    this.userSubject.next(user);
                }
                return x;
            }));
    }

    delete(id: string) {
        return this.http.delete(`/api/users/${id}`)
            .pipe(map(x => {
                // auto logout if the logged in user deleted their own record
                if (id == this.userValue?._id) {
                    this.logout();
                }
                return x;
            }));
    }
}

function stringi(ob: any, path = ''): string {
    if (typeof ob === 'object') {
        if (path.length)
            return Object.keys(ob).map(k => stringi(ob[k], `${path}[${k}]`)).join('');
        else
            return Object.keys(ob).map(k => stringi(ob[k], k)).join('');
    }
    else
        return '&' + path + '=' + ob;
}
